// @ts-ignore
import { IModelConstructor } from '../interfaces/IModelConstructor';
import { InputVM } from './InputVM';
import { withQuerySchema } from '../traits/withQuerySchema';
import { action, computed, makeObservable, override, set } from 'mobx';
import { handler, makeMetadata, property, transformer } from '../helpers/decorators';
import { equals } from '../helpers/equals';
import { normalizing } from '../helpers/normalizing';

export class FormVM extends withQuerySchema(InputVM) {
  /**
   * @hidden
   * @protected
   */
  constructor(...args: any[]) {
    super(...args);
    makeObservable(this);
    makeMetadata(this);
  }

  fields: any[] = [];

  URI: string = undefined;

  @action
  updateValue(value: object): this {
    return this.setValue({ ...this.value, ...value });
  }

  @override
  setDefaultValue(value: object): this {
    super.setDefaultValue(value);
    if (this.value === undefined) super.setValue(value);
    return this;
  }

  /**
   * @hidden
   * @param field
   * @param value
   * @param defaultValue
   */
  @action
  $updateForPureInput(field: string, value: any, defaultValue: any) {
    value = normalizing(value);

    // 将 `defaultValue` 值同步到 FORM VM 的`value`中
    if (defaultValue !== undefined && !equals(this.defaultValue?.[field], defaultValue)) {
      if (this.value === undefined) this.setValue({});
      if (this.defaultValue === undefined) this.setDefaultValue({});
      set(this.value, field, defaultValue);
      set(this.defaultValue, field, defaultValue);
    }

    // 将 `value` 值同步到 FORM VM 的`value`中
    // 可能是表达式, 需要同步处理
    if (value !== undefined && !equals(this.value?.[field], value)) {
      if (this.value === undefined) this.setValue({});
      set(this.value, field, value);
    }
  }

  @handler
  @override
  onChange(value: object) {
    // 此处过程的调用是为了没有VM情况下的值变更后, 将表单值同步到`VM` 中
    this.setValue(value);
  }

  @handler
  @action
  onConditionChange(value: any) {
    this.setState({ condition: value });
  }

  @handler
  @action
  onFieldGroupChange(value: any) {
    this.setState({ fieldGroup: value });
  }

  @handler
  @action
  onFormFieldsChange(value: any) {
    this.setState({ formFields: value });
  }

  @property
  @computed
  get initialValues() {
    return this.defaultValue;
  }

  set initialValues(value: any) {
    this.setDefaultValue(value);
  }

  @transformer
  private $valueSetterTransformer(value: object): object {
    const { fields, URI } = this;
    if (fields === undefined || URI === undefined) return value;
    return { SYS$META$URI: URI, ...value };
  }
}
